import { useEffect, useState } from "react";
// react redux
import { useSelector, useDispatch } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, Box, Button } from "@mui/material";
import { setOpen } from "../../redux/features/notify/notifySlice";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    TableGrid,
    ThreeDotsLoader,
    StatusFilterBox,
    PushUserNotification,
} from "../../components";
import { usersCols } from "../../utils/gridCols/usersCols";
import { errorAlert } from "../../utils/alerts/alerts";
// global state  type
import { ReduxUserReducerState } from "../../types/global";

const Users = () => {
    const dispatch = useDispatch();
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const open = useSelector((state: any) => state.notify.open);
    const { page, setPage } = usePageParams();
    const [users, setUsers] = useState([]);
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(24);
    const [totalItems, setTotalItems] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [filterValues, setFilterValues] = useState({
        status: "",
    });
    const [currentUserData, setCurrentUserData] = useState({
        id: "",
        name: "",
    });
    // close notify user dialog
    const handleClose = () => {
        dispatch(setOpen(false));
    };
    // get all users
    useEffect(() => {
        setLoading(true);
        EnhancedAxios(null, userToken)
            .get(
                `/admin/users?page=${page}&paginate=${itemsPerPage}&sorts=${sortValue}&q=${searchValue}&filters=${filterValues.status},roles:ex:3`
            )
            .then((res: AxiosResponse) => {
                setUsers(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, sortValue, searchValue, filterValues]);
    return (
        <Stack gap="20px">
            <PageTitle title="ادراة المستخدمين" />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <StatusFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            {loading ? (
                <ThreeDotsLoader />
            ) : users.length === 0 ? (
                <p className="center-text">لا يوجد مستخدمين لعرضهم</p>
            ) : (
                <TableGrid
                    rows={users}
                    cols={usersCols}
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={page}
                    setCurrentPage={setPage}
                />
            )}
            <PushUserNotification handleClose={handleClose} open={open} />
        </Stack>
    );
};

export default Users;
